import React from 'react';
import { useTranslation } from 'react-i18next';
import { isOverdue } from 'utils/dateUtils';

interface FeesStatusProps {
  status: 'paid' | 'partially_paid' | 'pending' | 'failed' | 'overdue' | 'coming';
  text?: string;
  dateDue?: string;
}

const FeesStatusBadge: React.FC<FeesStatusProps> = ({ status, text, dateDue }) => {
  const { t } = useTranslation();
  const getBadgeStatus = () => {
    switch (status) {
      case 'paid':
        return 'success';
      case 'partially_paid':
        return 'warning'; 
      case 'overdue':
        return 'danger';
      case 'coming':
        return 'info';
      case 'failed':
        return 'danger';
      default:
        return 'danger';
    }
  };

  const getDefaultText = () => {
    switch (status) {
      case 'paid':
        return t('fees_status.paid');
      case 'partially_paid':
        return t('fees_status.partially_paid');
      case 'overdue':
        return t('fees_status.overdue');
      case 'coming':
        return t('fees_status.coming');
      case 'failed':
        return t('fees_status.failed');
      default:
        return t('unknown');
    }
  };

  return (
    <span className={`badge badge-soft-${getBadgeStatus()} d-inline-flex align-items-center`}>
      <i className="ti ti-circle-filled fs-5 me-1"></i>
      {text || getDefaultText()}
    </span>
  );
};

export default FeesStatusBadge;